import { ResourceTypes } from 'model/party/resources/resources';
import Debug from 'debug';
const debug = Debug('model:actions:walkUpkeep');

/**
 * The walk phase is a race: the player has one in-game day to reach the first town.
 *
 * Health is the timer. Each phase takes an equal share of whatever is left, so it lands on
 * exactly zero as the deadline expires regardless of the starting health (5 by default, 100
 * under the test env). Reaching zero fires the existing die/death path via resources.delta.
 */
const notification = (health, isNight) => {
  if (health <= 0) return 'the road takes what is left';
  return isNight ? 'the cold gets into the bones' : 'the sun is punishing';
};

const attempt = ({ party }) => {
  const health = party.resources.attribs.health.value;
  const remaining = party.phasesToTown;

  // Last phase takes everything, so the deadline is exact rather than approximate.
  const cost = remaining > 1 ? Math.ceil(health / remaining) : health;

  return { success: true, cost: { health: Math.max(0, cost) } };
};

const executeSideEffects = (context, result) => {
  const { party, calendar } = context;

  party.phasesToTown = Math.max(0, party.phasesToTown - 1);

  // Reveal health the first time the road starts taking it, so the timer is legible even if
  // the player has not walked far enough to unlock the meter yet.
  party.phases.enableResource(ResourceTypes.Health);

  // Goes through delta so onResourceChanged sees the crossing to zero and triggers death.
  party.resources.delta({ health: -result.cost.health }, context);

  return { notification: notification(party.resources.attribs.health.value, calendar?.isNight()) };
};

const walkUpkeep = {
  title: '',
  enabled: ({ party }) => party.phase?.name === 'path' && party.resources.attribs.health.value > 0,
  execute: context => {
    const result = attempt(context);
    const { notification } = executeSideEffects(context, result);

    debug('cost', result.cost.health, 'phases left', context.party.phasesToTown);
    return { result, notification };
  }
};

export default walkUpkeep;
